var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewReturnInfoSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57821 2.91194C4.8091 3.55436 2.75 6.03342 2.75 9C2.75 9.41421 2.41421 9.75 2 9.75C1.58579 9.75 1.25 9.41421 1.25 9C1.25 4.71579 4.71579 1.25 9 1.25C9.2702 1.25 9.51952 1.39534 9.65265 1.63047C9.78578 1.8656 9.78214 2.15417 9.64312 2.38587L8.59313 4.13587C8.38002 4.49105 7.91933 4.60623 7.56414 4.39312C7.20896 4.18001 7.09378 3.71932 7.30689 3.36413L7.57821 2.91194ZM22 14.25C22.4142 14.25 22.75 14.5858 22.75 15C22.75 19.2842 19.2842 22.75 15 22.75C14.7298 22.75 14.4805 22.6047 14.3474 22.3695C14.2142 22.1344 14.2179 21.8458 14.3569 21.6141L15.4069 19.8641C15.62 19.5089 16.0807 19.3938 16.4359 19.6069C16.791 19.82 16.9062 20.2807 16.6931 20.6359L16.4218 21.0881C19.1909 20.4456 21.25 17.9666 21.25 15C21.25 14.5858 21.5858 14.25 22 14.25Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 8.20999L12.64 6.17999C12.24 5.96999 11.77 5.96999 11.37 6.17999L7.61002 8.20999C7.34002 8.35999 7.17004 8.64999 7.17004 8.97999C7.17004 9.30999 7.34002 9.59999 7.61002 9.74999L11.37 11.78C11.57 11.89 11.79 11.94 12.01 11.94C12.23 11.94 12.45 11.89 12.65 11.78L16.41 9.74999C16.68 9.59999 16.85 9.30999 16.85 8.97999C16.84 8.64999 16.67 8.35999 16.4 8.20999Z",
    fill: "#FF0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.74 12.47L7.23999 10.72C6.96999 10.59 6.65999 10.6 6.39999 10.76C6.13999 10.92 5.98999 11.19 5.98999 11.49V14.8C5.98999 15.37 6.31001 15.89 6.82001 16.14L10.32 17.89C10.44 17.95 10.57 17.98 10.71 17.98C10.87 17.98 11.02 17.94 11.16 17.85C11.42 17.69 11.57 17.42 11.57 17.12V13.81C11.57 13.24 11.26 12.73 10.74 12.47Z",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.59 10.76C17.33 10.6 17.02 10.59 16.75 10.72L13.25 12.47C12.74 12.73 12.42 13.24 12.42 13.81V17.12C12.42 17.42 12.57 17.69 12.83 17.85C12.97 17.94 13.12 17.98 13.28 17.98C13.41 17.98 13.54 17.95 13.67 17.89L17.17 16.14C17.68 15.88 18 15.37 18 14.8V11.49C18 11.19 17.85 10.92 17.59 10.76Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReturnInfoSectionIcon);
export default __webpack_public_path__ + "3aaedea5ee5ec6e854bf3fe9d2f0f518.svg";
export { ForwardRef as ReactComponent };